import { Alert, Slide, Snackbar } from "@mui/material";
import React from "react";
import { useTheme } from "@mui/material";

function MuiSnackbarAlert({
  open,
  onClose,
  message,
  backgroundColor,
  severity,
  autoHideDuration,
}) {
  const theme = useTheme();

  return (
    <Snackbar
      anchorOrigin={{
        vertical: "top",
        horizontal: "center",
      }}
      open={open}
      autoHideDuration={autoHideDuration || 1500}
      onClose={onClose}
      TransitionComponent={Slide}
    >
      <Alert
        onClose={onClose}
        severity={severity || "warning"}
        sx={{
          width: "100%",
          borderRadius: "5px",
          backgroundColor: backgroundColor || theme.palette.secondary.main,
          color: "white",
        }}
      >
        {message ? message : ""}
      </Alert>
    </Snackbar>
  );
}

export default MuiSnackbarAlert;
